export default __webpack_public_path__ + "static/media/rounded-plus-grey-icon.3470553c.svg";